import { createApi } from '@reduxjs/toolkit/query/react';
import { GenericResponse, IPrecio } from '@/redux/models';
import customFetchBase from './customFetchBase';


export const precioApi = createApi({
    reducerPath: 'precioApi',
    baseQuery: customFetchBase,
    tagTypes: ['precios'],
    endpoints: (builder) => ({
        obtenerPrecioInformes: builder.query<IPrecio[], void>({
            query: () => ({
                url: 'precio/getAllPrecios',
                method: 'GET',
                credentials: 'include',
            }),
            transformResponse: (response: GenericResponse) => {
                const rawPrecios = response.data;
                const groupedPrecios: any = {};
                rawPrecios.forEach((precio: any) => {
                    if (!groupedPrecios[precio.tipo]) {
                        groupedPrecios[precio.tipo] = {
                            id: precio.id,
                            tipo: precio.tipo,
                            key: [precio.key],
                            tipoInforme: precio.tipoInforme,
                            precio: [precio.precioInforme],
                            costo: [precio.costoInforme],
                            velocidad: [precio.velocidad],
                            updated_at: precio.updated_At,
                        };
                    } else {
                        const group = groupedPrecios[precio.tipo];
                        group.key.push(precio.key);
                        group.precio.push(precio.precioInforme);
                        group.costo.push(precio.costoInforme);
                        group.velocidad.push(precio.velocidad);
                    }
                });
                const precios: IPrecio[] = Object.values(groupedPrecios);
                return precios;
            },
        }),
        actualizarPrecio: builder.mutation<GenericResponse, { key: string, precio: number, costo: number }>({
            query: ({ key, precio, costo }) => ({
                url: `precio/updatePrecioInforme`,
                method: 'PUT',
                credentials: 'include',
                params: {
                    key,
                    precioInforme: precio,
                    costoInforme: costo
                },
            }),
            invalidatesTags: [{ type: 'precios', id: 'LIST' }],
        }),
        obtenerPrecioPorTipoInforme: builder.query<GenericResponse, { key: any, velocidad: number }>({
            query: ({ key, velocidad }) => ({
                url: `precio/getPrecio?key=${key}&velocidad=${velocidad || -1}`,
                method: 'GET',
                credentials: 'include',
            })
        }),
    }),
});

export const {
    useObtenerPrecioInformesQuery,
    useActualizarPrecioMutation,
    useObtenerPrecioPorTipoInformeQuery,
} = precioApi;
